// extracted by mini-css-extract-plugin
export default {"title":"About_title__gMK4V","focus":"About_focus__pHGM5","about":"About_about__N9JfE","full":"About_full__XFb7f"};